{
  "pagination": {
    "ListDeploymentEvents": {
      "input_token": "nextToken",
      "output_token": "nextToken",
      "limit_key": "maxResults",
      "result_key": "deploymentEvents"
    },
    "ListDeployments": {
      "input_token": "nextToken",
      "output_token": "nextToken",
      "limit_key": "maxResults",
      "result_key": "deployments"
    },
    "ListWorkloadDeploymentPatterns": {
      "input_token": "nextToken",
      "output_token": "nextToken",
      "limit_key": "maxResults",
      "result_key": "workloadDeploymentPatterns"
    },
    "ListWorkloads": {
      "input_token": "nextToken",
      "output_token": "nextToken",
      "limit_key": "maxResults",
      "result_key": "workloads"
    }
  }
}
